<template>

    <div class="container">

        <app-head title="Favorites" />

        <account-link />

        <div class="my-4">
            <h1>{{ __('Favoriten') }}</h1>
            <div class="mb-4">
                {{ __('Herzlich Willkommen im :app, hier haben Sie die Möglichkeit ihre favorisierten Lieferanten auszuwählen. Dies führt zu einer Vorsortierung in den Kategorien und der Suche, so das sie schneller zum gewünschten Ergebnis kommen. Sie haben jederzeit die Möglichkeit Ihre Einstellungen im Profil nachträglich zu bearbeiten."', {app: $page.props.app.name}) }}
            </div>
        </div>

        <form @submit.prevent="form.post(route('favorites.submit'))">

            <h2>{{ __('Suppliers') }}</h2>
            <p>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="checkAll('suppliers', 'favorite_suppliers')">{{ __('Alle auswählen') }}</button>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="uncheckAll('suppliers', 'favorite_suppliers')">{{ __('Alle abwählen') }}</button>
            </p>
            <div class="list-group mb-4" style="">
                <label class="list-group-item list-group-item-action d-flex align-items-center" :class="{active: form.favorite_suppliers.includes(supplier.id)}" v-for="supplier in suppliers">
                    <span class="col-auto">
                        <input class="me-3" 
                               type="checkbox"
                               :value="supplier.id" 
                               v-model="form.favorite_suppliers"
                               autocomplete="off" />
                    </span>
                    <div class="col">
                        {{ supplier.name }}
                    </div>
                </label>
            </div>

            <!--            <h2>{{ __('Manufacturers') }}</h2>
                        <p>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="checkAll('manufacturers', 'favorite_manufacturers')">{{ __('Alle auswählen') }}</button>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="uncheckAll('manufacturers', 'favorite_manufacturers')">{{ __('Alle abwählen') }}</button>
            </p>
            <div class="list-group mb-4" style="max-height: 300px; overflow-y: auto;">
                <label class="list-group-item list-group-item-action d-flex align-items-center" :class="{active: form.favorite_manufacturers.includes(manufacturer.id)}" v-for="manufacturer in manufacturers">
                    <span class="col-auto">
                        <input class="me-3" 
                               type="checkbox"
                               :value="manufacturer.id" 
                               v-model="form.favorite_manufacturers"
                               autocomplete="off" />
                    </span>
                    <div class="col">
                        {{ manufacturer.name }}
                    </div>
                </label>
                        </div>-->

<!--            <h2>{{ __('Brands') }}</h2>
            <p>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="checkAll('brands', 'favorite_brands')">{{ __('Alle auswählen') }}</button>
                <button type="button" class="btn btn-sm btn-outline-dark" @click="uncheckAll('brands', 'favorite_brands')">{{ __('Alle abwählen') }}</button>
            </p>
            <div class="list-group mb-4" style="max-height: 300px; overflow-y: auto;">
                <label class="list-group-item list-group-item-action d-flex align-items-center" :class="{active: form.favorite_brands.includes(brand.id)}" v-for="brand in brands">
                    <span class="col-auto">
                        <input class="me-3" 
                               type="checkbox"
                               :value="brand.id" 
                               v-model="form.favorite_brands"
                               autocomplete="off" />
                    </span>
                    <div class="col">
                        {{ brand.name }}
                    </div>
                </label>
            </div>-->

            <submit-button :form="form" />

        </form>
        
    </div>

</template>

<script>
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import AccountLink from '@/shared/AccountLink';

    export default {
        props: [
            'suppliers',
//            'brands',
//            'manufacturers',
//            'selectedBrands',
            'selectedSuppliers',
//            'selectedManufacturers',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    action: this.action,
//                    favorite_brands: this.selectedBrands,
                    favorite_suppliers: this.selectedSuppliers,
//                    favorite_manufacturers: this.selectedManufacturers,
                }),
            }
        },
        components: {
            CheckboxInput,
            SubmitButton,
            AccountLink,
        },
        methods: {
            checkAll(type, model) {
                _.each(this[type], (o) => {
                    this.form[model].push(o.id);
                });
            },
            uncheckAll(type, model) {
                this.form[model] = [];
            },
        },
    }
</script>